export const GET_STATISTICS_DATA_REQUEST = 'GET_STATISTICS_DATA_REQUEST';
export const GET_STATISTICS_DATA_SUCCESS = 'GET_STATISTICS_DATA_SUCCESS';
export const GET_STATISTICS_DATA_ERROR   = 'GET_STATISTICS_DATA_ERROR';